import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";
import AlbumIcon from "@mui/icons-material/Album";
import StarIcon from "@mui/icons-material/Star";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { baseURL } from "../../constants/url";
import Watermark from "../../assets/images/no_product.jpg";
import uploadIcon from "../../assets/images/add-image.png";
import { useNavigate } from "react-router-dom";

const MyOrder = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 10;

  // Review states
  const [showPopup, setShowPopup] = useState(false);
  const [rating, setRating] = useState(0);
  const [description, setDescription] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedProductName, setSelectedProductName] = useState("");
  const [selectedProductId, setSelectedProductId] = useState(null);

  const token = localStorage.getItem("authToken");
  const userId = parseInt(localStorage.getItem("user_id") || "0");

  
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await fetch(`${baseURL}common/orders_history/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!res.ok) throw new Error("Failed to fetch orders");
        const data = await res.json();
        setOrders(data);
        console.log("order data", data)
      } catch (err) {
        console.error("Error fetching orders:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, [token]);

  const handleReviewClick = (productName, productId) => {
  setSelectedProductName(productName);
  setSelectedProductId(productId); // now this gets correct variant ID
  setShowPopup(true);
};


  const closePopup = () => {
    setShowPopup(false);
    setRating(0);
    setDescription("");
    setSelectedImage(null);
  };

  const handleStarClick = (index) => {
    setRating(index + 1);
  };

  const handleSubmit = async () => {

          console.log("form data value print",{
            token,
            userId,
            selectedProductId,
            rating,
            description,
            selectedImage
        });

      if (!token || !userId || !selectedProductId || rating === 0 || !description) {
      return Swal.fire({
        icon: "error",
        title: "Missing Data",
        text: "Please fill in all fields before submitting.",
      });
    }

    const formData = new FormData();
    formData.append("variant", selectedProductId);
    formData.append("user", userId);
    formData.append("rating", rating);
    formData.append("review", description);
    if (selectedImage) {
      formData.append("images", selectedImage);
    }

    try {
      const res = await fetch(`${baseURL}common/ratings/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.detail || "You’ve already reviewed this product.");
      }

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Review submitted successfully.",
      });

      closePopup();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message || "Failed to submit review.",
      });
    }
  };

  // Pagination
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);
  const totalPages = Math.ceil(orders.length / ordersPerPage);
  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const popupStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  };

  const modalContentStyle = {
    background: "#fff",
    padding: "2rem",
    borderRadius: "8px",
    textAlign: "center",
    minWidth: "400px",
  };

  if (loading) return <p className="text-center mt_30">Loading your orders...</p>;
  if (orders.length === 0)
             return 
             <div className="container-fluid text-center pt_40 pb_40">
                <img src={Watermark}
                  alt="No Products Found"
                  className="no-products-img"
                  style={{ width: "300px", opacity: 0.3 }}
                />
                <h4 className="pt_20">No Products Available</h4>
              </div>;

  return (
    <>
      <Header />
      <div className="container mt_30">
        <div class="heading_common mt_15"><h3>My Orders</h3></div>
        {currentOrders.map((order) => (
          <div key={order.id} className="card_common2 mb_20 pt_10 pb_10 pl_10 pr_10">
            <div className="order-items order_hover mt_10">
              <div className="row ">
                <div className="col-md-12">
                  <div className="d_flex justify_sp_between mb_5 order_sumery_content">
                    <h6 className="color_green">Order ID: {order.razorpay_order_id}</h6>
                    <p className="color_orange_radish">Total Amount: ₹{order.amount}</p>
                  </div>
                </div>
              </div>
              {order.items.map((item, idx) => (
                <Link  to={`/trackorder/${order.id}`}  key={idx} title="Click to Track Order Details">
                <div className={`row hover_bg pt_10 pb_10 ${
                    idx !== order.items.length - 1 ? "border_bottom_gray_1" : ""
                  }`}
                >
                  <div className="col-md-1">
                     
                    <img src={item.product_image} alt="img"
                       className="order_img_size"
                    /> 
                  </div>
                  <div className="col-md-6">
                    <Link  to={`/trackorder/${order.id}`}>
                    <p className="font_bold font_12 color_lightDark">{item.product_name}</p>
                    <p className="font_12">Quantity: {item.quantity}</p>
                    </Link>
                  </div>
                  <div className="col-md-2">
                    <p className="font_12">Price: ₹{item.price}</p>
                  </div>
                  <div className="col-md-3">
                    <p className="font_bold d_flex align_center gap_5 color_green font_size_12">
                      <AlbumIcon className="icon_width_12" /> Delivered on{" "}
                      {new Date(order.created_at).toLocaleDateString()}
                    </p>
                    <p>
                      Status: <strong className="color_green">{order.status}</strong>
                    </p>
                    <div className="d_flex gap_10 align__center mt_10">
                      <Link
                        to="#"
                        onClick={() =>
                          handleReviewClick(item.product_name, item.variant)
                        }
                      >
                        Rate and Review
                      </Link>
                    </div>
                  </div>
                </div>
                </Link>
              ))}
            </div>
          </div>
        ))}

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="d_flex justify_center align_center gap_10 mt_20">
            <button onClick={handlePrev} disabled={currentPage === 1} className="pagination_btn">
              Previous
            </button>
            <span className="font_bold">Page {currentPage} of {totalPages}</span>
            <button onClick={handleNext} disabled={currentPage === totalPages} className="pagination_btn">
              Next
            </button>
          </div>
        )}
      </div>

      {/* Review Popup */}
      {showPopup && (
        <div style={popupStyle}>
          <div style={modalContentStyle} className="modalStyle">
            <h6 className="text_left">Rate: {selectedProductName}</h6>
            <div className="text_left mb_10">
              {[...Array(5)].map((_, index) => (
                <StarIcon
                  key={index}
                  onClick={() => handleStarClick(index)}
                  style={{
                    color: index < rating ? "#ffc107" : "#ccc",
                    cursor: "pointer",
                  }}
                />
              ))}
            </div>
            <div className="form-group text_left">
              <label className="required">Review</label>
              <textarea
                rows="5"
                placeholder="Write your review here..."
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              ></textarea>
            </div>
            <div className="pb_15 pt_15s">
              <label className="upload-box">
                <span className="upload-placeholder">
                  <img
                    src={uploadIcon}
                    width="30"
                    alt="upload"
                  />
                </span>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setSelectedImage(e.target.files[0])}
                />
              </label>
            </div>
            <div className="d_flex justify_sp_between align__center mt_15">
              <button className="saveForm" onClick={handleSubmit}>
                Save
              </button>
              <button className="cross_btn" onClick={closePopup}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <Subscribe />
      <Footer />
    </>
  );
};

export default MyOrder;
